module.exports = __webpack_public_path__ + "static/media/Plus2BreathingActivity.da62119c.mp3";